import React from 'react'
import styled from 'styled-components'
import { planSvg, sideSvg, tableSvg } from '../svg/surveySvg'
import theme from 'live/services/theme'

const types = [
    { type: 'table', title: 'Table', svg: tableSvg },
    { type: 'plan', title: 'Plan', svg: planSvg },
    { type: 'side', title: 'Side', svg: sideSvg }
]

const ViewSelector = styled.div`
    display: flex;
    flex-direction: column;
    margin: 18px 0 0 18px;

    span {
        font-family: 'SourceSansPro-Semibold', Arial, 'Helvetica Neue', Helvetica, sans-serif;
    }
`
const ContainerButton = styled.div`
    display: flex;
    button {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 80px;
        height: 44px;
        margin: 2px 10px 18px 0;
        padding: 2px;
        border-radius: 3px;
        border: solid 1px ${({ dark, isEditor }) => (dark && !isEditor ? theme['darker-bg'] : theme['light-borders'])};
        background-color: ${({ dark, isEditor }) => (dark && !isEditor ? theme['text-color'] : theme['gray-lighter'])};
        font-size: 11px;
        color: ${({ dark, isEditor }) => (dark && !isEditor ? 'white' : theme['gray-darker'])};

        &.selected {
            background-color: ${({ dark, isEditor }) =>
                dark && !isEditor ? theme['darker-bg'] : theme['gray-dark-bg']};
        }

        &:hover {
            border-color: ${({ dark, isEditor }) =>
                dark && !isEditor ? theme['input-text-color'] : theme['input-borders']};
            box-shadow: 0px 0px 8px rgba(55, 163, 239, 0.2);
        }
    }
`

export default function ({ value, onChange, dark = true, isEditor = false }) {
    return (
        <ViewSelector>
            <span>View:</span>
            <ContainerButton dark={dark} isEditor={isEditor}>
                {types.map(elem => (
                    <button className={value === elem.type ? 'selected' : null} onClick={() => onChange(elem.type)}>
                        <elem.svg />
                        {elem.title}
                    </button>
                ))}
            </ContainerButton>
        </ViewSelector>
    )
}
